// Eligibility Icons
export const ICON_YEARS_OLD = 'YearsOld'
export const ICON_EMPLOYEES = 'Employees'
export const ICON_FUNDING = 'Funding'

// Feature Icons
export const ICON_BUDGET_FRIENDLY = 'BudgetFriendly'
export const ICON_SCALE_GROW = 'ScaleGrow'
export const ICON_OPEN_SOURCE = 'OpenSource'
export const ICON_ROI = 'ROI'
export const ICON_ALL_IN_ONE = 'AllInOne'
export const ICON_COMMUNITY = 'Community'
